import { useSelector } from "react-redux";
import CalculationTypes from "../../../../components/DataCollection/Unifier/CalculationTypes/CalculationTypes";
import Page404 from "../../../../components/Page404/Page403";
import { selectUserData } from "../../../../features/userSlice";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";

const CalculationTypesScreen = () => {
  const response = useSelector(selectUserData);
  const hasUnifierViewCalculationTypes = CheckPermissions(
    response?.data?.products?.data_collection,
    "unifier",
    "view_calculation_types"
  );

  return (
    <>
      {hasUnifierViewCalculationTypes ? (
        <>
          <CalculationTypes />
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default CalculationTypesScreen;
